// /posts DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리.

import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip } from "components/list";
import { IPost } from "../interfaces";
import { boardKindMeta, resolveStatusMeta } from "./postsStatus";

export const postsColumns: GridColDef<IPost>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  {
    field: "title",
    headerName: "제목",
    width: 260,
    minWidth: 160,
  },
  { field: "content", headerName: "내용", type: "string", width: 300, minWidth: 180, sortable: false },
  {
    field: "boardKind",
    headerName: "유형",
    type: "string",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(boardKindMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "userId",
    headerName: "글쓴이ID",
    type: "string",
    width: 96,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "boardId",
    headerName: "게시판ID",
    type: "string",
    width: 96,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  { field: "updatedDate", headerName: "수정일", type: "string", width: 236, minWidth: 180, align: "center", headerAlign: "center" },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
